import { updateChatbotState } from "./Utils";
import {API_BASE} from "../../../services/apirest";

export const hacerConsulta = async (newMessage, setState, createChatBotMessage) => {
  try {
    const mensajeLimpio = newMessage.toLowerCase();
    let usuario;

    // Si el mensaje inicia con "consultar usuario", se extrae el usuario desde el mensaje
    if (mensajeLimpio.startsWith("consultar usuario")) {
      usuario = newMessage.split(" ")[2];
      console.log("🥵", usuario)
    }
    // Si el mensaje es "consultar mis ventas", se obtiene el número de vendedor desde el localStorage
    else if (mensajeLimpio.startsWith("consultar mis ventas")) {
        usuario = localStorage.getItem("numero_vendedor");
        console.log("🥵", usuario);
    } else {
      // Si el mensaje no coincide con ninguno de los casos, no se hace nada
      return;
    }

    if (!usuario) {
      return updateChatbotState(
        setState,
        createChatBotMessage(
          "No se encontró el número del vendedor. Por favor, inicia sesión o proporciona un usuario."
        )
      );
    }

    // Se realiza la consulta a la API utilizando el usuario obtenido
    const response = await fetch(`${API_BASE}/chatbot.php?usuario=${usuario}`);
    if (!response.ok) throw new Error("Error al obtener datos de la API");

    const dbData = await response.json();
    if (dbData.error) {
      return updateChatbotState(
        setState,
        createChatBotMessage(`No se pudo obtener la información: ${dbData.error}`)
      );
    }

    const instalaciones = dbData.result?.data || [];
    if (dbData.status === "success" && instalaciones.length > 0) {
      updateChatbotState(
        setState,
        createChatBotMessage(
          `El usuario ${usuario} tiene un total de ${instalaciones.length} instalación(es):`,
          { widget: "instalacionesMensaje", payload: { instalaciones } }
        )
      );
      return;
    }

    updateChatbotState(
      setState,
      createChatBotMessage(`El usuario ${usuario} no tiene instalaciones registradas.`)
    );
  } catch (error) {
    updateChatbotState(
      setState,
      createChatBotMessage(`Hubo un error procesando tu solicitud: ${error.message}`)
    );
  }
};
